export const actionTypes = {
    SHOW_GDPR_POPUP: 'SHOW_GDPR_POPUP',
    CLOSE_GDPR_POPUP: 'CLOSE_GDPR_POPUP',
};

export const showGdprPopup = url => ({
    type: actionTypes.SHOW_GDPR_POPUP,
    url,
})

export const closeGdprPopup = () => ({
    type: actionTypes.CLOSE_GDPR_POPUP,
})



// WEBPACK FOOTER //
// /src/js/common/gdpr/gdpr.actions.js